// ERA Motor Marka Bloğu — CSS-only monogram + teknik grid detay.
// Marka kimliği: kurumsal antrasit, kontrollü amber vurgu.
import { cn } from "@/lib/utils";

/**
 * BrandMark — ERA monogram + serviste operasyon merkezi alt başlığı.
 * variant: "sidebar" (dikey blok) | "compact" (yatay küçük — header için).
 */
export function BrandMark({ variant = "sidebar", className, subtitle = true }) {
  if (variant === "compact") {
    return (
      <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-mark">
        <EraMonogram size={36} />
        <div className="min-w-0">
          <div className="font-display font-extrabold text-[15px] leading-none tracking-tight text-foreground">
            ERA <span className="text-primary">Motor</span>
          </div>
          {subtitle && (
            <div className="text-[9.5px] uppercase tracking-[0.22em] text-muted-foreground mt-1 hidden sm:block">
              Servis Operasyon Merkezi
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={cn("relative overflow-hidden", className)} data-testid="brand-mark">
      {/* Teknik blueprint çizgileri — çok hafif */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] dark:opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />
      <div className="relative flex items-center gap-3 px-4 py-4">
        <EraMonogram size={44} />
        <div className="min-w-0 flex-1">
          <div className="font-display font-extrabold text-[17px] leading-none tracking-tight text-foreground">
            ERA <span className="text-primary">Motor</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-1.5 flex items-center gap-1.5">
            <span className="inline-block h-px w-4 bg-primary/60" />
            Servis Operasyon Merkezi
          </div>
        </div>
      </div>
      {/* Alt ince amber ipi — plaka esintili */}
      <div aria-hidden className="absolute bottom-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
    </div>
  );
}

/**
 * EraMonogram — Saf CSS/SVG monogram. Servis anahtar simgesi + ERA kısaltması.
 * Amber aksan + koyu antrasit yüzey.
 */
export function EraMonogram({ size = 40 }) {
  const s = size;
  return (
    <div
      className="relative shrink-0 rounded-md border border-border shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]"
      style={{
        width: s,
        height: s,
        background:
          "linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary) / 0.75) 100%)",
      }}
      data-testid="brand-monogram"
    >
      {/* İnce hasp/plaka çizgisi */}
      <div
        aria-hidden
        className="absolute inset-[3px] rounded-[4px] border border-white/25"
      />
      {/* ERA yazısı */}
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="font-display font-black tracking-tighter text-primary-foreground"
          style={{ fontSize: Math.round(s * 0.42), letterSpacing: "-0.06em" }}
        >
          ERA
        </span>
      </div>
      {/* Sağ üst amber işaret */}
      <div
        aria-hidden
        className="absolute top-1 right-1 h-1.5 w-1.5 rounded-full"
        style={{ background: "hsl(38 92% 60%)" }}
      />
    </div>
  );
}
